var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('homehero',{staticClass:"limit"}),_c('navigationgrid',{attrs:{"showing":[true,true,true,true,false]}}),_c('iconslider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }